import gql from 'graphql-tag';

export default gql`
  subscription deleteAgentNotification {
    notification: deleteAgentNotification {
      id
    }
  }
`;
